<template>
    <v-container fluid>
        <v-card class="pa-6" color="grey-lighten-4" rounded="sm" elevation="2">
            <h3 class="text-h6 mb-6 font-weight-medium">{{ texts.title }}</h3>
            <Bar :chart-data="chartData" :chart-options="chartOptions" :styles="chartStyles" />
        </v-card>
    </v-container>
</template>

<script>
import moment from 'moment';
import { Bar } from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
    name: 'SessionsChart',
    components: { Bar },
    props: {
        sessionCountByDay: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chartStyles: {
                height: '400px',
                width: '100%',
                position: 'relative'
            }
        };
    },
    computed: {
        texts() {
            return {
                title: this.$t('Statistic.chart.title'),
                sessions: this.$t('Statistic.chart.sessions'),
                yAxis: this.$t('Statistic.chart.yAxis'),
                xAxis: this.$t('Statistic.chart.xAxis')
            };
        },
        chartData() {
            const entries = Object.entries(this.sessionCountByDay)
                .map(([date, value]) => ({
                    date,
                    sessionCount: value?.visitNumber || 0
                }))
                .filter(({ sessionCount }) => sessionCount > 0);

            return {
                labels: entries.map(e => moment(e.date).format('DD/MM')),
                datasets: [
                    {
                        label: this.texts.sessions,
                        data: entries.map(e => e.sessionCount),
                        backgroundColor: '#42A5F5',
                        borderRadius: 4,
                        barThickness: 20
                    }
                ]
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'x',
                scales: {
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: this.texts.yAxis
                        },
                        ticks: {
                            // ✅ Display of whole numbers only
                            callback: function (value) {
                                return Number.isInteger(value) ? value : '';
                            }
                        }
                    },
                    x: {
                        title: {
                            display: true,
                            text: this.texts.xAxis
                        },
                        ticks: {
                            autoSkip: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false
                    }
                }
            };
        }
    }
};
</script>

<style scoped></style>
